// --------------------------------------------------------
// CARD PERIODIC EXAM AREA - CardPeriodicExamArea
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import moment from 'moment';
import React from 'react'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import IconExames from "../../assets/imgs/iconExames.svg";
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { Text } from '../UI/generalLayout/Layout.styled';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARD PERIODIC EXAM AREA INTERFACE
// --------------------------------------------------------

interface ICardPeriodicExamArea {
    exame: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardPeriodicExamArea = ({ exame }: ICardPeriodicExamArea) => {
    // --------------------------------------------------------
    // CARD PERIODIC EXAM AREA PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();

    const isExamComResultado = exame.resultado !== null;

    const PendingIcon = () => {
        return <HighlightOffIcon
            style={{ color: "#64748B", marginTop: 14 }}
        />
    }

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            {!isMobile ? (<div style={{ flexDirection: "row", display: "flex", width: '100%', marginBottom: 10 }}>
                <div style={{ flexDirection: "row", display: "flex", width: '55%' }}>
                    <img style={{ marginRight: 10 }} src={IconExames} alt="" />
                    <Text>{exame.nome}</Text>
                </div>
                <div>
                    {isExamComResultado ? 
                        (<Text>{moment(exame.resultado.dataColeta, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Text>)
                        :(<div style={{ display: 'flex', flexDirection:'row', gap: 5 }}><PendingIcon /><Text>Pendente</Text></div>)}
                </div>
            </div>) : (
                <div style={{ flexDirection: "row", display: "flex", width: '100%', marginBottom: 30 }}>
                    <img style={{ marginRight: 10, width: 60 }} src={IconExames} alt="" />

                    <div style={{ flexDirection: "column", display: "flex" }}>
                        <Text style={{ marginBottom: -15 }}>{exame.nome}</Text>
                        {isExamComResultado && <Text style={{ marginBottom: -15 }}>{`Solicitação: ${moment(exame.resultado.dataColeta, 'YYYY-MM-DD').format('DD/MM/YYYY')}`}</Text>}
                        {isExamComResultado && exame.resultado.dataColeta === null && (<Text>Pendente</Text>)}
                    </div>
                </div>)}
        </>
    )
    // --------------------------------------------------------
}

export default CardPeriodicExamArea